import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-record',
  templateUrl: './record.component.html',
  styleUrl: './record.component.css'
})
export class RecordComponent {
  @Input() image!: string;
  @Input() name!: string;
  @Input() price!: string;
  @Input() timeProp!: string;
  @Input() paid!: boolean;

  showISOStringToDateAndTime(isoString: string) {
    if (!isoString) {
      return '';
    }
    const date = new Date(isoString);
    return `${date.toLocaleDateString()} - ${date.toLocaleTimeString()}`;
  }
} 